import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import Cookies from "js-cookie";
import { FetchDataTypes } from "../api/api";
import { Line } from "react-chartjs-2";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { after, indexOf } from "lodash";
import _ from "lodash";
import moment from "moment";
import groupBy, { concat } from "lodash";
import {
  Chart,
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler,
} from "chart.js";
import { Pagination } from "../components";
import { CellClickedEvent } from "ag-grid-community";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable, { UserOptions } from "jspdf-autotable";
Chart.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  PointElement,
  LineElement,
  Filler
);
export interface IOlympicData {
  sectorname: string;
  balanceBySector: any;
  sectorHoldingsPct: any;
}
export interface IOlympicDataDetails {
  symbol: string,
qty: number,
price: number,
marketValue: number,
securityHoldingsPct: number,
securityHoldingsPctInSector: number,
}
interface jsPDFCustom extends jsPDF {
  autoTable: (options: UserOptions) => void;
}
function SectorAllocationTblLeft({ chartTitle }: { chartTitle: string }) {
  const dataGridRefMain = useRef<AgGridReact<IOlympicData>>(null);
  const dataGridRefDetails = useRef<AgGridReact<IOlympicDataDetails>>(null);
  const [sectorDetails, setSectorDetails] = useState<any>(null);
  const [sectorCount, setSectorCount] = useState<any>(null);
  const [sectorNameCount, setSectorNameCount] = useState<any>(null);
  const [SectorCurrentPage, setSectorCurrentPage] = useState(1);
  const [SectorNameCurrentPage, setSectorNameCurrentPage] = useState(1);
  const [getSetorName, setGetSetorName] = useState(null);
  const [gridApi, setGridApi] = useState<any>(null);
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [isSearch, setIsSearch] = useState(false);
  const [allocationsBySector, setAllocationsBySector] = useState<any>(null);
  const [updatedData, setUpdatedData] = useState<any>(null)
  const selectedClient:any = Cookies.get("client")
  // useEffect(() => {
  //   FetchDataTypes("SectorActivity", Cookies.get("newJwt"))
  //     .then((response) => response.json())
  //     .then((response) => {
  //       setSectorAllocation(response);
  //     });
  // }, []);

  useEffect(() => {
    FetchDataTypes("AllocationsDashboard", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setSectorDetails(response);
        setSectorCount(response);
        setSectorNameCount(response);
      });
  }, []);

  useEffect(() => {
    FetchDataTypes("AllocationsBySector", parseInt(selectedClient), Cookies.get("newJwt"))
      .then((response) => response.json())
      .then((response) => {
        setAllocationsBySector(response);
        setSectorCount(response);
        setSectorNameCount(response);
      });
  }, []);

  const newData = _.groupBy(sectorDetails, "countryName");

  

  const sectorNameData = sectorDetails?.filter(
    (filter_by: { sectorName: null }) => filter_by.sectorName === getSetorName
  );

  const SectorpageHandler = (pageNumbers: any, index: any) => {
    setSectorDetails(
      sectorCount.slice(pageNumbers * 10 - 10, pageNumbers * 10)
    );
    setSectorCurrentPage(pageNumbers);
  };

  const SectorpageNameHandler = (pageNumbers: any, index: any) => {
    setSectorDetails(
      sectorNameCount.slice(pageNumbers * 10 - 10, pageNumbers * 10)
    );
    setSectorNameCurrentPage(pageNumbers);
  };

  function formateAsPercent(num: any) {
    return new Intl.NumberFormat("default", {
      style: "percent",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(num / 100);
  }

  function formateDataPrec(p: any) {
    return p.value >= 0 ? (
      <>{p.value === null ? "NA" : formateAsPercent(p.value)}</>
    ) : (
      <>
        <span className="text-danger">
          {"(" + formateAsPercent(p.value).slice(1) + ")"}
        </span>
      </>
    );
  }
  function currencyFormat(num: any) {
    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }

  function formateDataCurr(p: any) {
    return p.value >= 0 ? (
      <>{p.value === null ? "NA" : "$" + currencyFormat(p.value)}</>
    ) : (
      <>
        <span className="text-danger">
          {"(" + "$" + currencyFormat(p.value).slice(1) + ")"}
        </span>
      </>
    );
  }
  function formateDatabuyCurr(p: any) {
    return p.value >= 0 ? (
      <>
        {p.value === null ? (
          "NA"
        ) : (
          <span className="text-success ">{"$" + currencyFormat(p.value)}</span>
        )}
      </>
    ) : (
      <>
        <span className="text-danger">
          {"(" + "$" + currencyFormat(p.value).slice(1) + ")"}
        </span>
      </>
    );
  }
  function onGridReady(params: any) {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  }
  

  function onGridReadyDetails(params: any) {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
  }

  const handleChange = (e: any) => {
    gridApi.setQuickFilter(e.target.value);
    setIsSearch(e.target.value ? true : false);
  };

  const onBtExportMain = useCallback(() => {
    dataGridRefMain.current!.api.exportDataAsExcel();
  }, []);

  const onBtExportDetails = useCallback(() => {
    dataGridRefDetails.current!.api.exportDataAsExcel();
  }, []);
  

  const exportSectorData = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(12);

    const title = "Sector";
    const headers = [
      [
       " sectorname",
        "balanceBySector",
        "sectorHoldingsPct"
      ],
    ];

    const data = allocationsBySector.map((e: any) => [
      e.sectorname,
      e.balanceBySector,
      e.sectorHoldingsPct,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("sectorReport.pdf");
  };

  const exportSectorDataDetails = () => {
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size) as jsPDFCustom;

    doc.setFontSize(12);

    const title = "Sector";
    const headers = [
      [
        "symbol",
        "qty",
        "price",
        "marketValue",
        "securityHoldingsPct",
        "securityHoldingsPctInSector",
      ],
    ];
    
    const exportDataNew = sectorNameData && sectorNameData.length ? sectorNameData : sectorDetails

    const data = exportDataNew.map((e: any) => [
      e.symbol,
      e.qty,
      e.price,
      e.marketValue,
      e.securityHoldingsPct,
      e.securityHoldingsPctInSector,
    ]);

    let content = {
      startY: 50,
      head: headers,
      body: data,
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save("sectorReport.pdf");
  };
  const SectorAllocationTblComumns = [
    {
      field: "sectorname",
      headerName: "Sector Name",
      width: 230,
      resizable: true,
      sortable: true,
      cellClass: "cell-wrap-text",
      flex: 1,
      filter: "agSetColumnFilter",
      floatingFilter: true,
      onCellClicked: (event: CellClickedEvent) => setGetSetorName(event.value),
    },

    {
      field: "balanceBySector",
      headerName: "Balance",
      width: 80,
      cellClass: "cell-wrap-text",
      cellRenderer: formateDataCurr,
      //headerClass: "headerTextAlign",
    },
    {
      field: "sectorHoldingsPct",
      headerName: "%",
      cellRenderer: formateDataPrec,
      width: 130,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
  ];
  const SectorAllocationTblRightColumns = [
    {
      field: "symbol",
      headerName: "Symbol",
      width: 100,
      sortable: true,
      cellClass: "cell-wrap-text",
      //flex: 1,
      floatingFilter: true,
    filter: "agTextColumnFilter",
    },

    {
      field: "qty",
      headerName: "Qty",
      width: 60,
      cellClass: "cell-wrap-text",
      //cellRenderer: formateDataCurr,
      //headerClass: "headerTextAlign",
    },
    {
      field: "price",
      headerName: "Price",
      cellRenderer: formateDataCurr,
      width: 100,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "marketValue",
      headerName: "Market Value",
      cellRenderer: formateDataCurr,
      width: 130,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "securityHoldingsPct",
      headerName: "Holdings %",
      cellRenderer: formateDataPrec,
      width: 100,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
    {
      field: "securityHoldingsPctInSector",
      headerName: "%",
      cellRenderer: formateDataPrec,
      width: 100,
      cellClass: "cell-wrap-text textAlign",
      headerClass: "headerTextAlign",
    },
  ];
  return (
    <div className="row w-100">
      <div className="card mr-2" style={{ width: "42%", marginRight: "15px" }}>
        <div className="d-inline-block col-sm-3 w-100 py-3">
          <input
            type="text"
            id="filter-text-box"
            placeholder="Search..."
            onInput={handleChange}
            className="form-control float-start mx-4 w-50"
          />
          <div className="col-sm-12 my-3 text-end">
            <i
              className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
              style={{ fontSize: "16px" }}
              onClick={onBtExportMain}
            ></i>
            <i
              className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
              onClick={() => exportSectorData()}
              style={{ fontSize: "16px" }}
            ></i>
          </div>
        </div>
        <div className="card-body">
          <div className="chart chart-xs">
            <div className="chartjs-size-monitor">
              <div className="chartjs-size-monitor-shrink">
                <div
                  className="ag-theme-alpine"
                  style={{
                    height: "600px",
                    width: "100%",
                  }}
                >
                  <AgGridReact
                    ref={dataGridRefMain}
                    onGridReady={onGridReady}
                    rowData={allocationsBySector}
                    columnDefs={SectorAllocationTblComumns}
                    rowHeight={40}
                    pagination={true}
                  paginationPageSize= {20}
                  //paginationAutoPageSize={true}
                  />
                </div>
               
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card" style={{ width: "56%" }}>
        <div className="col-sm-3 pt-4 w-100 ps-3 selectedName justify-content-between align-items-center">
          {sectorNameData &&
            sectorNameData?.map((e: any) => {
              return <span>Sector: &nbsp;&nbsp;{e.sectorName}</span>;
            })}{" "}
          
               <div className="text-end">
               <i
                 className="align-middle me-2 far fa-fw fa-file-excel cursor-pointer"
                 style={{ fontSize: "16px" }}
                 title="Export Excel"
                 onClick={onBtExportDetails}
               ></i>
               <i
                 className="align-middle me-2 far fa-fw fa-file-pdf cursor-pointer"
                 onClick={() => exportSectorDataDetails()}
                 title="Export PDF"
                 style={{ fontSize: "16px" }}
               ></i>
             </div>

             
          
        </div>
        <div className="card-body">
          <div className="chart chart-xs">
            <div className="chartjs-size-monitor">
              <div className="chartjs-size-monitor-shrink">
                <div
                  className="ag-theme-alpine"
                  style={{
                    height: "600px",
                    width: "100%",
                  }}
                >
                  <AgGridReact
                    ref={dataGridRefDetails}
                    onGridReady={onGridReadyDetails}
                    rowData={
                      sectorNameData && sectorNameData.length
                        ? sectorNameData
                        : sectorDetails
                    }
                    columnDefs={SectorAllocationTblRightColumns}
                    rowHeight={40}
                    pagination={true}
                  paginationPageSize= {20}
                  //paginationAutoPageSize={true}
                  />
                </div>
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { SectorAllocationTblLeft };
